import React from 'react';
import {Modal, Button} from 'react-bootstrap';
import {Header, Body, Footer, Title} from 'react-bootstrap/lib/Modal'
import ModalWindow from './ModalWindow';

export default class AlertWindow extends ModalWindow
{
	constructor(title, text, style) {
		super(title, text, null, style);
	}

	show(dispatch) {
		if (__MOBILE__) {
			navigator.notification.alert(this.text, null, this.title);
		}
		else {
			const modal = <Modal animation={false} show={true} onHide={() => this.hide()} bsStyle={this.style}>
				<Header closeButton>
					<Title>{this.title}</Title>
				</Header>
				<Body>
				<div style={{padding: '20px 5px'}}>
					{this.text}
				</div>
				</Body>
				<Footer>
					<Button onClick={() => this.hide()} bsStyle="primary">OK</Button>
				</Footer>
			</Modal>;
			this.dispatchWindow(dispatch, modal);
		}
	}
}


// WEBPACK FOOTER //
// ./src/reactis/reactis-modal/src/AlertWindow.js